import script from "./ModifyPlan.vue?vue&type=script&setup=true&lang=js"
export * from "./ModifyPlan.vue?vue&type=script&setup=true&lang=js"

import "./ModifyPlan.vue?vue&type=style&index=0&id=080651f3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-080651f3"]])

export default __exports__